import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const masterDataBankListService = (
  params: Types.MasterDataBankListRequest
) =>
  RestAPIClient.call<Types.MasterDataBankListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const masterDataBankListShortService = (
  params: Types.MasterDataBankListRequest
) =>
  RestAPIClient.call<Types.MasterDataBankListShortResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.ListShort,
    config: {
      requireAuthentication: true,
      byPassError: true,
      params,
    },
  });
